import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './styles.css';
import './experience.css';
import './giao-dien.css';

// Sau mỗi lần deploy, tab mở từ trước còn chạy bản cũ và không tải được các
// tệp mã đã bị thay. Vite báo qua sự kiện này; tải lại một lần để lấy bản mới.
// Mốc trong sessionStorage chặn vòng lặp nếu lỗi vẫn còn (ví dụ mất mạng).
if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', (e) => {
    try {
      const khoa = 'fvn-tai-lai-sau-deploy';
      const lan = Number(sessionStorage.getItem(khoa) || 0);
      if (Date.now() - lan < 60000) return;
      sessionStorage.setItem(khoa, String(Date.now()));
      e.preventDefault();
      window.location.reload();
    } catch { /* để ToolErrorBoundary hiện nút tải lại */ }
  });
}

const goc = document.getElementById('root');

const cay = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Trang đã được render sẵn thành HTML lúc build thì hydrate, giữ nguyên DOM có
// sẵn. Nếu vì lý do nào đó chưa có (chạy dev), dựng mới bình thường.
if (goc.hasChildNodes()) hydrateRoot(goc, cay);
else createRoot(goc).render(cay);
